import ChartApi from "../../../pages/Ministerio-aprobacion/Ministerio-aprobacion-v2/ChartApi";

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApi piePagina={'Se visualiza la aprobación de ministros con 40% o más de conocimiento.'}/>
          </div>
        </div>
      </div>
    </div>
  )
}
